export const headerText = "Allocated through period";

export const maxTickCount = 9;
